import { MessageAnt } from "../redux/slices/ui/uiAction"
import { MessageType } from "../types/messageType"

const mapperErrorResponse = (response = { msg: "", text: "", code: 0 }) => {
    const codeResponse = response?.code || 0
    const type = (codeResponse > 4000 && codeResponse < 5000) ? "warning" : "error"
    return {
        msg: response?.msg || "",
        text: response?.text || "",
        code: codeResponse,
        type
    }
}


export const errorResponseGetMsg = (error) => {

    if (!error?.data) return [
        mapperErrorResponse({ msg: "Error del servidor", text: "Error not indentification", code: 1 })
    ]

    const { payload, status } = error.data

    if (status === 500) return [
        mapperErrorResponse({ msg: "Error del servidor", text: "Error not indentification", code: 1 })
    ]

    if (!payload?.errors) return [
        mapperErrorResponse({ msg: "Error del servidor", text: "Error not indentification", code: 1 })
    ]

    return payload.errors
        .map(({ msg = null }) => mapperErrorResponse(msg))
        .filter((response) => response.code !== 0)
}

export const msgErrorNotfication = (type = "error", msg = "") => {
    MessageAnt(MessageType[type], msg)
}